import { afterNextRender, Component, inject,  } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
  imports: [RouterModule],
})
export class LoadingComponent  {
  router = inject(Router);
  constructor() {
    afterNextRender(() => {
      // redirigimos a auth
      this.router.navigateByUrl('/auth');
    });
   }
}
